import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import useLanguageChange from "../../hooks/useLanguageChange";
import { setAgentSendLanguage } from "../../reducers/chat-reducer";
import { AGENT_SEND_LANGUAGES, getAgentSendLanguageByCode } from "../../constants/TranslationConstants";

const AgentSendLanguageSelector = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();

    const { agentSendLanguage } = useSelector((state) => state.chatReducer);

    const selectedLanguageObj = useMemo(() => {
        return getAgentSendLanguageByCode(agentSendLanguage) || AGENT_SEND_LANGUAGES.find((lang) => lang.code === "en");
    }, [agentSendLanguage]);

    const handleLanguageChange = (languageCode) => {
        dispatch(setAgentSendLanguage(languageCode));
    };

    return (
        <div className='agent-send-language-selector'>
            <div className='dropdown agent-send-language-dropdown dropup'>
                <button
                    className='btn dropdown-toggle agent-send-dropdown-btn'
                    type='button'
                    id='agent-send-language-dropdown'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                    data-testid='agent-send-language-dropdown'
                >
                    <span className='send-label-text'>{localisedValues["send_message_in"]}: </span>
                    <span className='selected-language-name'>{selectedLanguageObj?.languageName}</span>
                    <span className='dropdown-arrow icon-down-arrow-light'></span>
                </button>
                <div className='dropdown-menu' aria-labelledby='agent-send-language-dropdown'>
                    <div className='dropdown-menu-in agent-send-language-list custom-scroll-thin'>
                        <ul>
                            {AGENT_SEND_LANGUAGES.map((language) => (
                                <li key={language.code}>
                                    <div className='dropdown-item-div'>
                                        <button
                                            className={clsx("dropdown-item", language.code === agentSendLanguage && "active")}
                                            onClick={() => handleLanguageChange(language.code)}
                                            data-testid={`agent-send-lang-${language.code}`}
                                        >
                                            <span className='language-name'>{language.languageName}</span>
                                        </button>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgentSendLanguageSelector;
